module.exports = __webpack_public_path__ + "img/poster_id_gq.2bc4dac5.png";